import React, { FC } from 'react';
import { Divider, Typography } from 'antd';

import { getClanWarProgress } from '@services/cstool/recovery-account';

import ClanWarDefenseTeamSearch from './clan-war-defense-team-search';
import ProgressSearch from './progress-search';

const { Title } = Typography;

const ClanWar: FC = () => (
  <div className="flex flex-col">
    <Title level={4}>Clan War Progress</Title>
    <ProgressSearch
      fetchProgress={getClanWarProgress}
      downloadFileName={(playerId) => `clan-war-${playerId}.txt`}
    />
    <Divider />
    <Title level={4}>Clan War Defense Team</Title>
    <ClanWarDefenseTeamSearch />
  </div>
);

export default ClanWar;
